import { useEffect, useState } from "react"
import { useCallback } from "react"
import { useContext } from "react"
import { MdSearch } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import UserContext from "../../Context/UserContext"

export default function EventsAsExhibitor(){
  const {user, seeAs} = useContext(UserContext)
  const navigate = useNavigate()
  const [eventList, setEventList] = useState([])
  const [search, setSearch] = useState('')
  const [events, setEvents] = useState([])

  const reloadEventList = useCallback((events)=>{
    if(events){
      setEventList(events)
    }else{
      if(seeAs){
        setEvents([...seeAs.events])
        setEventList([...seeAs.events])
      }else{
        setEvents([...user.events])
        setEventList([...user.events])
      }
    }
  },[user, seeAs])

  useEffect(()=>{
    reloadEventList()
  }, [])

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    let filteredList = []
    events.forEach((event)=>{
      if(event.name.toLowerCase().includes(search.toLowerCase())){
        filteredList = [...filteredList, event]
      }
    })
    reloadEventList(filteredList)
  }

  const handleClick = (eventId) =>{
    navigate(`/exhibitor/event/${eventId}`)
  }

  return <div className="container mx-auto px-4">
    <form onSubmit={handleSearchSubmit} className='flex gap-2 my-4 justify-center flex-row'>
      <input type="text" className="w-full max-w-[400px] sm:w-fit mx-auto sm:mx-0" placeholder="Buscar eventos" onChange={(e)=>{setSearch(e.target.value)}} value={search}/>
      <button className="action-btn"><MdSearch size={25}/></button>
    </form>
    <h1 className="text-stone-600 font-semibold text-xl py-2">Mis eventos</h1>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {eventList.map((event, index)=>{return(
        <button key={index} className='group-btn' onClick={()=>{handleClick(event.id)}}>{event.name}</button>
      )})}
    </div>
  </div>
}